import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Company } from './shared/classes/lookups/company.model';
import { Province } from './shared/classes/lookups/province.model';
import { Area } from './shared/classes/lookups/area.model';
import { Shaft } from './shared/classes/lookups/shaft.model';
import { Section } from './shared/classes/lookups/section.model';
import { Contact } from './shared/classes/contact.model';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  apiURL =  environment.apiEndPoint;

  constructor(private httpClient: HttpClient) {}

  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  // HttpClient API get() method => Fetch company list
  getCompany(): Observable<Company> {
    return this.httpClient.get<Company>(this.apiURL + 'company')
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  // HttpClient API get() method => Fetch province list
  getProvince(): Observable<Province> {
    return this.httpClient.get<Province>(this.apiURL + 'province/1')
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  // HttpClient API get() method => Fetch area list
  getArea(provinceId): Observable<Area> {
    return this.httpClient.get<Area>(this.apiURL + 'area/' + provinceId)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  // HttpClient API get() method => Fetch shaft list
  getShaft(companyId, countryId, provinceId, areaId): Observable<Shaft> {
    return this.httpClient.get<Shaft>(this.apiURL + 'shaft/' + companyId + '/' + countryId + '/' + provinceId + '/' + areaId)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  // HttpClient API get() method => Fetch section list
  getSection(shaftId): Observable<Section> {
    return this.httpClient.get<Section>(this.apiURL + 'section/' + shaftId)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  // HttpClient API get() method => Fetch section list
  getContacts(sectionId): Observable<Contact> {
    return this.httpClient.get<Contact>(this.apiURL + 'contact/' + sectionId)
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  // Error handling
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }
}
